import { Suspense, lazy } from "react"
import PrivateRoute from "../private-route"
import { PageLoader } from "src/shared/components"
import MainLayout from "src/shared/layouts/main/main-layout"
import Dashboard from "src/modules/dashboard/pages/Home"
import ShipmentStatusList from "src/modules/shipment-status/pages/ShipmentStatusList"
import MainGridList from "src/modules/main-grid/pages/MainGridList"
import InvoiceList from "src/modules/invoice/pages/InvoiceList"
import CreateInvoice from "src/modules/invoice/pages/create-invoice"
import { Outlet } from "react-router-dom"

// Lazy load all module components for better performance
// Consignment
const ConsignmentList = lazy(() => import("src/modules/consignment/pages/ConsignmentList"))

// Container Types
const ContainerTypeList = lazy(() => import("src/modules/container-type/pages/ContainerTypeList"))

// Descriptions
const DescriptionsList = lazy(() => import("src/modules/descriptions/pages/DescriptionsList"))
// const CreateDescriptions = lazy(() => import("src/modules/descriptions/pages/CreateDescriptions"))
// const UpdateDescriptions = lazy(() => import("src/modules/descriptions/pages/UpdateDescriptions"))

// Port
const PortList = lazy(() => import("src/modules/port/pages/PortList"))
// const CreatePort = lazy(() => import("src/modules/port/pages/CreatePort"))
// const UpdatePort = lazy(() => import("src/modules/port/pages/UpdatePort"))

// Shipper
const ShipperList = lazy(() => import("src/modules/shipper/pages/ShipperList"))

// Vendor
const VendorList = lazy(() => import("src/modules/vendor/pages/VendorList"))

// Shipping Line
const ShippingLineList = lazy(() => import("src/modules/shipping-line/pages/ShippingLineList"))

// Vessel
const VesselList = lazy(() => import("src/modules/vessel/pages/VesselList"))

// Cities
const ContainerList = lazy(() => import("src/modules/container/pages/ContainerList"))

// Invoice Particular
const InvoiceParticularList = lazy(() => import("src/modules/invoice-particular/pages/InvoiceParticularList"))

// Customer
const CustomerList = lazy(() => import("src/modules/customer/pages/CustomerList"))

const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader isLoading />}>{children}</Suspense>
)

const appRoutes = {
  path: "app",
  element: (
    <PrivateRoute>
      <Suspense fallback={<PageLoader isLoading />}>
        <MainLayout />
      </Suspense>
    </PrivateRoute>
  ),
  children: [
    {
      path: "",
      element: <Dashboard />
    },

    // Consignment Routes
    {
      path: "consignment",
      element: (
        <LazyWrapper>
          <ConsignmentList />
        </LazyWrapper>
      )
    },

    // Shipping Statuses Routes
    {
      path: "shipment-status",
      element: (
        <LazyWrapper>
          <ShipmentStatusList />
        </LazyWrapper>
      )
    },

    // Container Types Routes
    {
      path: "container-type",
      element: (
        <LazyWrapper>
          <ContainerTypeList />
        </LazyWrapper>
      )
    },

    // Descriptions Routes
    {
      path: "descriptions",
      element: (
        <LazyWrapper>
          <DescriptionsList />
        </LazyWrapper>
      )
    },

    // Port Routes
    {
      path: "port",
      element: (
        <LazyWrapper>
          <PortList />
        </LazyWrapper>
      )
    },

    // Shipper Routes
    {
      path: "shipper",
      element: (
        <LazyWrapper>
          <ShipperList />
        </LazyWrapper>
      )
    },

    // Vendor Routes
    {
      path: "vendor",
      element: (
        <LazyWrapper>
          <VendorList />
        </LazyWrapper>
      )
    },

    // Shipping Line Routes
    {
      path: "shipping-line",
      element: (
        <LazyWrapper>
          <ShippingLineList />
        </LazyWrapper>
      )
    },

    // Vessel Routes
    {
      path: "vessel",
      element: (
        <LazyWrapper>
          <VesselList />
        </LazyWrapper>
      )
    },
    // main grid
    {
      path: "main-grid",
      element: (
        <LazyWrapper>
          <MainGridList />
        </LazyWrapper>
      )
    },

    // Container Routes
    {
      path: "container",
      element: (
        <LazyWrapper>
          <ContainerList />
        </LazyWrapper>
      )
    },

    // Invoice Routes
    {
      path: "invoice",
      element: <Outlet />,
      children: [
        {
          index: true,
          element: (
            <LazyWrapper>
              <InvoiceList />
            </LazyWrapper>
          )
        },
        {
          path: "create",
          element: (
            <LazyWrapper>
              <CreateInvoice />
            </LazyWrapper>
          )
        }
        // {
        //   path: "preview/:id",
        //   element: (
        //     <LazyWrapper>
        //       <InvoicePreview />
        //     </LazyWrapper>
        //   )
        // }
      ]
    },

    // Invoice Particular Routes
    {
      path: "invoice-particular",
      element: (
        <LazyWrapper>
          <InvoiceParticularList />
        </LazyWrapper>
      )
    },

    // Customer Routes
    {
      path: "customer",
      element: (
        <LazyWrapper>
          <CustomerList />
        </LazyWrapper>
      )
    }
  ]
}

export default appRoutes
